<template>
  <div>
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item>首页</a-breadcrumb-item>
      <a-breadcrumb-item>教务中心</a-breadcrumb-item>
      <a-breadcrumb-item>收款二维码</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="main-body students">
      <a-tabs :animated="false" :activeKey="activeKey" @change="changeTab">
        <a-tab-pane key="1">
          <span slot="tab">收款二维码<a-badge :count="0" /></span>
          <skewm v-if="activeKey==='1'"/>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab">收款记录<a-badge :count="0" /></span>
          <skjl v-if="activeKey==='2'"/>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import skewm from './skewm/index'
import skjl from './skjl/index'

export default {
  components: {
    skewm,
    skjl,
  },
  data() {
    return {
      activeKey: '1'
    }
  },

  methods: {
    changeTab(key) {
      this.activeKey = key
    }
  }
}
</script>

